// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import tabSection from "./tabSection.js";
import onScroll from "./onScroll.js";
import smoothScroll from "./smoothScroll.js";
import infiniteScroll from "./infiniteScroll";
import contactForm from "./contactForm.js";
import { autoSlider } from "./autoSlider.js";

// Call the menu and infinite scroll functions
tabSection();
menuOpen();
onScroll();
smoothScroll();
infiniteScroll();
contactForm();

// FAQ
document.addEventListener("DOMContentLoaded", function () {
    const faqs = document.querySelectorAll(".r-faq");

    faqs.forEach((faq, index) => {
        const title = faq.querySelector(".r-faq-title");
        const text = faq.querySelector(".r-faq-text");

        // Open the first FAQ by default
        if (index === 0) {
            faq.classList.add("active");
            text.style.maxHeight = text.scrollHeight + "px";
        }

        title.addEventListener("click", function () {
            const isActive = faq.classList.contains("active");

            // Close all FAQs before opening the clicked one
            faqs.forEach((item) => {
                item.classList.remove("active");
                item.querySelector(".r-faq-text").style.maxHeight = "0";
            });

            if (!isActive) {
                faq.classList.add("active");
                text.style.maxHeight = text.scrollHeight + "px";
            }
        });
    });
});
